var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.workspaceUserTypes),function(wUser){return _c('members-row',{key:wUser,attrs:{"list-type":wUser}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }